"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "merate": {
    "03ecb47e": [{
      "hkey": "5d426667",
      "slug": "merate",
      "name": "Merate",
      "primary": true,
      "skipSearch": false
    }],
    "cicognola": [{
      "hkey": "5d426667",
      "slug": "merate",
      "name": "Merate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8f2aed8": [{
      "hkey": "5d426667",
      "slug": "merate",
      "name": "Merate",
      "primary": true,
      "skipSearch": false
    }],
    "pagnano": [{
      "hkey": "5d426667",
      "slug": "merate",
      "name": "Merate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5aa71104": [{
      "hkey": "5d426667",
      "slug": "merate",
      "name": "Merate",
      "primary": true,
      "skipSearch": false
    }],
    "sartirana": [{
      "hkey": "5d426667",
      "slug": "merate",
      "name": "Merate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;